const actionData = {
  type: "event",
  name: "hospitality.ShowContentItem",
  contentType: "Article",
};

export { actionData };
